import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'time',
  renderInput: ({ value, onChange }) => (
    <input
      type="time"
      value={(value as string) ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
      className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-1.5 text-sm text-text-primary focus:border-accent-500 focus:ring-1 focus:ring-accent-500 focus:outline-none"
    />
  ),
  renderCell: (_field, value) => {
    if (!value) return '—';
    return String(value).slice(0, 5); // HH:MM
  },
  validate: (value, field) => {
    if (!value) return field.isRequired ? 'Pole wymagane' : null;
    return null;
  },
  defaultValue: null,
});
